<template>
<div>
  <section class="registerbox " >
    <div class="formHeader" style="height:50px;line-height:50px;background:	#333">
      <div style="float:left; padding-top:7px;">
        <h5 class="title is-5" style="color:#fff;padding-left:10px;margin-top:5px"><b>Mark Pickup Cancel Shipment </b></h5>
      </div>
    </div>
    <div class="box">
      <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
        <div class="columns">
          <div class="column">
            <div class="field is-horizontal" style="width:500px;">
              <div class="field-label is-normal">
                <label class="label" style="width: 101px;">Shipment Id</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <p class="control">
                    <input class="input" type="text" name="shipmentid" v-model="customer.shipmentid" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.shipmentid') }" placeholder="Enter shipment id ">
                    <span v-show="errors.has('form-1.shipmentid')" class="help is-danger">{{ errors.first('form-1.shipmentid') }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field is-horizontal" style="width:500px;">
              <div class="field-label is-normal">
                <label class="label" style="width: 101px;">deliverystatuscode</label>
              </div>
              <div class="field">
                <p>
                  <div class="select" style="width: 317px;">
                    <select v-model="customer.deliverystatuscode" name="deliverystatuscode" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.deliverystatuscode') }">
                <option :value="selected">--Select--</option>
                <option  value="900">Pickup not ready with vendor</option>
              </select>
                  </div>
                  <span v-show="errors.has('form-1.deliverystatuscode')" class="help is-danger">{{ errors.first('form-1.deliverystatuscode') }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <footer class="column has-text-left" style="padding-left:125px;">
          <button class="button is-info" type="submit" style="background:rgb(34, 139, 34)">Pickup Cancel</button>
          <span class="button is-primary" @click="clear" style="background:rgb(119, 136, 153)">Clear</span>
        </footer>
      </form>
    </div>
  </section>
  <div class="modal" :class="{'is-active' : toggleInfo}">
    <form v-on:submit.prevent="toggleInfoModal()">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Cancel Pickup</p>
          <button class="delete" type="button" @click="closemodal"></button>
        </header>
        <section class="modal-card-body" style="padding-right: 219px;">
          <div class="field is-horizontal" style="padding-left: 171px;">
            <div class="field" align="center">
              <p class="control">
                Are you sure to cancel pickup?
              </p>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot" style="padding-left:560px">
          <button class="button is-info" type="submit">Ok</button>
        </footer>
      </div>
    </form>
  </div>
</div>
</form>
</div>
</div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
export default {
  data: function () {
    return {
      name: 'MarkPickupCancel',
      customer: {},
      data: [],
      toggleInfo: false
    }
  },
  created: function () {},
  methods: {
    validateForm  (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.toggleInfo = !this.toggleInfo
        }
      })
    },
    clear: function () {
      this.customer = {}
      this.errors.clear('form-1')
      var searchlisting = document.getElementById('searchlisting')
      searchlisting.style.display = 'none'
    },
    toggleInfoModal: function () {
      var searchvaluesarr = []
      var shipmentid = this.customer.shipmentid
      var statuscode = this.customer.deliverystatuscode
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      var searchvalues = shipmentid.split(',')
      for (var i = 0; i < searchvalues.length; i++) {
        searchvaluesarr.push(`${searchvalues[i]}`)
      }
      const customerGetAllobj = {
        shippingid: searchvaluesarr,
        deliverystatuscode: statuscode,
        lastmodifiedby: `${userInfo.sysemailid}`
      }
      this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster.svc/MarkPickupCancelShipment`, customerGetAllobj)
        .then((result) => {
          if (result.body.returnmsg === 'NoRecordsUpdated') {
           alert('No Records updated')
          } else {
            alert('Pickup cancelled successfully')
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
      this.toggleInfo = !this.toggleInfo
    },
    closemodal: function () {
      // console.log('closemodal')
      this.toggleInfo = !this.toggleInfo
    }
  }
}
</script>

